import api from "./api";
import { APIS } from "../endpoints";

/**
 * This function return songs data
 * @returns {Promise<Object>} - Function return Songs data
 */

export const getAllLocationsData = async (limit, page, searchTerm, filterOptions = {}) => {
    const response = await getLocationApiData(limit, page, searchTerm, filterOptions);
    return response;
};

const _isDefaultFilterOptions = (opts) => {
    if (!opts || typeof opts !== 'object') return true;
    const filters = opts.filters;
    const hasFilterValues = filters && typeof filters === 'object'
        && Object.values(filters).some((v) => Array.isArray(v) ? v.length > 0 : Boolean(v));
    if (hasFilterValues) return false;
    if (opts.search) return false;
    return true;
};

export const getLocationApiData = async (limit, page, searchTerm, filterOptions = {}) => {
    const formData = new FormData();
    formData.append('page', page);
    formData.append('limit', limit);

    if (!_isDefaultFilterOptions(filterOptions)) {
        const cleanedOptions = {
            ...filterOptions,
            filters: Object.fromEntries(
                Object.entries(filterOptions.filters || {}).filter(([, v]) =>
                    Array.isArray(v) ? v.length > 0 : Boolean(v)
                )
            ),
        };
        formData.append('filters', JSON.stringify(cleanedOptions));
    }

    if (searchTerm) {
        formData.append('search', searchTerm);
    }

    if (filterOptions.sortBy_v) {
        formData.append('sort_by', filterOptions.sortBy_v);
    }

    if (filterOptions.sortOrder_v) {
        formData.append('sort_order', filterOptions.sortOrder_v);
    }

    const params = new URLSearchParams(formData);

    const result = await api.get(`${APIS.BASE_URL}${APIS.adminLocation}`, {
        params: params
    })
    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const getManMadeHeritageData = async (alias) => {

    const result = await api.get(`${APIS.BASE_URL}${APIS.adminLocation}/${alias}/bodyofwork/man-made-heritage`)
    if (result) {
        return result?.data?.data;
    } else {
        return [];
    }
};

export const getManMadeHeritageRecordData = async (alias, recordAlias) => {
    const result = await api.get(`${APIS.BASE_URL}${APIS.adminLocation}/${alias}/bodyofwork/man-made-heritage/${recordAlias}`)
    if (result) {
        return result?.data;
    } else {
        return null;
    }
};
export const getLocationData = async (alias, tabSection, section) => {

    const result = await api.get(`${APIS.BASE_URL}${APIS.adminLocation}/${alias}/${tabSection}/${section}`)
    if (result) {
        return result?.data?.data;
    } else {
        return [];
    }
};

export const updateLocationData = async (alias, data, deletedValues) => {

    const payload = {
        ...data,
        deletedValues: deletedValues
    };

    const result = await api.put(`${APIS.BASE_URL}${APIS.adminLocation}/${alias}/introduction`, payload)
    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const updateLocationBasicData = async (alias, data, deletedValues) => {
    const payload = {
        ...data,
        deletedValues: deletedValues
    };

    const result = await api.put(`${APIS.BASE_URL}${APIS.adminLocation}/${alias}/general/basic`, payload)

    if (result) {
        return result?.data;
    } else {
        return {};
    }
};

export const updateLocationGeographicalDetailsData = async (alias, data, deletedData) => {
    const payload = {
        ...data,
        deletedData: deletedData
    };

    const result = await api.put(`${APIS.BASE_URL}${APIS.adminLocation}/${alias}/introduction`, payload)
    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const getLocationLandingPageData = async (alias, data, deletedValues) => {

    const payload = {
        ...data,
        deletedValues: deletedValues
    };

    const result = await api.get(`${APIS.BASE_URL}${APIS.adminLocation}/${alias}/general/landing-page`, payload)

    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const updateLocationLandingPageData = async (alias, data) => {

    const payload = {
        ...data
    };

    const result = await api.put(`${APIS.BASE_URL}${APIS.adminLocation}/${alias}/general/landing-page`, payload)

    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const updateManMadeHeritageData = async (alias, data) => {

    const payload = {
        ...data
    };

    const result = await api.put(`${APIS.BASE_URL}${APIS.adminLocation}/${alias}/bodyofwork/man-made-heritage`, payload)

    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const deleteLocationLandingPageData = async (alias, deletedValues) => {

    const payload = {
        deletedValues: deletedValues
    };

    const result = await api.delete(`${APIS.BASE_URL}${APIS.adminLocation}/${alias}/general/landing-page`, { data: payload })

    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const deleteManMadeHeritageData = async (alias, deletedValues) => {

    const payload = {
        deletedValues: deletedValues
    };

    const result = await api.delete(`${APIS.BASE_URL}${APIS.adminLocation}/${alias}/bodyofwork/man-made-heritage`, { data: payload })

    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const getLocationAliasSuggestions = async (limit, page, inputValue) => {
    const formData = new FormData();
    formData.append('page', page);
    formData.append('limit', limit);

    if (inputValue) {
        formData.append('search', inputValue); // Add search term
    }

    const params = new URLSearchParams(formData);
    const result = await api.get(`${APIS.BASE_URL}${APIS.locationlistAliasSuggestions}`, {
        params: params
    })

    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const getStatesData = async (inputValue) => {
    try {
        const formData = new FormData();
        formData.append('page', 1);
        formData.append('limit', 100);

        if (inputValue) {
            formData.append('search', inputValue); // Add search term
        }
        const params = new URLSearchParams(formData);
        const result = await api.get(`${APIS.BASE_URL}${APIS.statesIndia}`, {
            params: params
        });
        if (result?.data?.data && Array.isArray(result?.data?.data)) {
            return result?.data?.data?.map(state => ({
                label: state?.name || state?.alias,
                value: state?.alias || state?.name
            }));
        }
        return [];
    } catch (error) {
        console.error('Error fetching states data:', error);
        return [];
    }
};
